import React from 'react';

import Link from '../InternalLink';

const LinkedDesignerName = ({ designer, sewpatId }) => (
    <Link
        to={{
            type: 'NAVIGATED_TO_PATTERNS_FROM_DESIGNER',
            payload: {
                designerid: designer.id,
                sewpatId,
            },
        }}
    >
        {designer.name}
    </Link>
    );

export default LinkedDesignerName;



// WEBPACK FOOTER //
// ./src/components/designer/LinkedDesignerName.js